import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
// import PropertyDropdown from "./PropertyDropdown";
import TopRightPartnersDropdown from "./TopRightPartnersDropdown";
import tw from "tailwind-styled-components";
import axios from "axios";
import Config from "../Config";
import TopSearchDropdown from "../Components/TopSearchDropdown";
import { useLocation, useNavigate } from "react-router-dom";
import SideModal from "./SideModal";
import { MdOutlinePendingActions } from "react-icons/md";
import PendingTasksModal from "./PendingTask";

const useOutsideClick = (ref, callback) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, callback]);
};

const TopNavbar = () => {
  const navigate = useNavigate();
  const searchRef = useRef(null);
  const user = useSelector((state) => state.UserReducer.user);
  const properties = useSelector((state) => state.PropertyReducer.property);
  // const partners = useSelector((state) => state.PartnersReducer.partners);
  const location = useLocation();
  // const partners = useSelector((state) => state.PartnersReducer.partners);
  const pendingTasks = useSelector((state) => state.PendingTasksReducer?.pendingTasks);

  const [search, setSearch] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [query, setQuery] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isPendingTasksOpen, setIsPendingTasksOpen] = useState(false);
  const [pendingTasksCount, setPendingTasksCount] = useState(0);
  const isDashboardRoute = location.pathname === '/' ||
    location.pathname === '/dashboard';

  useEffect(() => {
    if (pendingTasks && isDashboardRoute) {
      let count = 0;

      if (pendingTasks.totalPendingTasks > 0) {
        count = pendingTasks.totalPendingTasks;
      }
      setPendingTasksCount(count);
    } else {
      setPendingTasksCount(0);
    }
  }, [pendingTasks, isDashboardRoute]);

  const fetchFunction = async () => {
    const response = await axios.get(`${Config.apiUrl}/inventory/search?s=${query}`, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
    return response.data;
  };

  useEffect(() => {
    if (query.length < 3) {
      setData([]);
      setSearchResult([]);
      setShowDropdown(false);
      return;
    }
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetchFunction();
        if (response.data.length == 0) throw new Error("Failed to fetch data");
        const data = response?.data;
        setSearchResult(data);
        setShowDropdown(true);
      } catch (error) {
        setSearchResult([]);
        setError(error.message);
        setShowDropdown(true);
      }
      setLoading(false);
    };
    const debounceTimer = setTimeout(fetchData, 500);
    return () => clearTimeout(debounceTimer);
  }, [query]);

  useOutsideClick(searchRef, () => {
    setShowDropdown(false);
  });

  const dispatch = useDispatch();
  const handleSearchSelection = (selectedOption) => {
    // const path = selectedOption?.status === 2
    //   ? `/tenantdetails/l/${selectedOption.id}/1`
    //   : `/tenantdetails/l/${selectedOption.id}`;

    // navigate(path, {
    //   state: {
    //     tabName: 'Passbook',
    //     tabKey: "totalDues",
    //   },
    // });
    navigate("/inventory/details", {
      state: {
        //propertyDetails: selectedOption,
        inventoryId: selectedOption?.id,
      },
    });
    setShowDropdown(false);
    setQuery("");
  };
  // const handleSearchSelection = (selectedOption) => {
  //   navigate(`/inventory/detail?inventoryId=${selectedOption?.id}`);

  //   setShowDropdown(false);
  //   setQuery("");
  // };

  const handleSearchChange = (e) => {
    setError(null);
    setQuery(e.target.value);
    if (e.target.value.length >= 3) {
      setShowDropdown(true);
    }
  };

  const handleSearchFocus = () => {
    if (query.length >= 3 && (searchResult.length > 0 || error)) {
      setShowDropdown(true);
    }
  };
  const handlePendingTasksClick = () => {
    setIsPendingTasksOpen(true);
  };

  const handlePendingTasksClose = () => {
    setIsPendingTasksOpen(false);

  };
  //border-b border-gray-200
  return (
    <>
      <div className="bg-white fixed top-0 transition-all duration-300
          left-0 lg:left-60 
          w-full lg:w-[calc(100%-15rem)]">
        <div className="h-[63px] flex items-center justify-between px-4 md:px-6">
          {user.userType !== 5 &&
            <div className="flex items-center space-x-2 hidden md:flex ml-10 lg:ml-2">
              <SearchContainer ref={searchRef} className="hidden md:block ml-10 lg:ml-2">
                <input
                  type="text"
                  placeholder="Search for inventory (name/location/size)..."
                  className="flex p-2 border border-gray-300 rounded-md w-[400px] text-sm text-gray-500 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                  value={query}
                  onChange={handleSearchChange}
                  onFocus={handleSearchFocus}
                />
                {showDropdown && searchResult && searchResult.length > 0 && (
                  <TopSearchDropdown onChange={handleSearchSelection} options={searchResult} />
                )}
                {showDropdown && error != null && (
                  <ul className="absolute mt-1 bg-white border border-gray-300 rounded-md shadow-md max-h-48 overflow-y-auto w-[400px] z-50">
                    <li className="px-4 py-2 text-gray-500">No results found</li>
                  </ul>
                )}
              </SearchContainer>

            </div>
          }
          <div className="md:hidden flex-1"></div>
          {/* {user.userType === 1 && partners?.length >= 1 &&
            <div className="flex items-center md:gap-6 gap-2">
                       {isDashboardRoute && (
                <div className="relative">
                  <button
                    onClick={handlePendingTasksClick}
                    className="flex items-center justify-center w-10 h-10 rounded-md bg-transparent hover:bg-gray-100 transition-colors duration-200 border border-gray-300"
                    title="Pending Tasks"
                  >
                    <MdOutlinePendingActions className="w-5 h-5 text-gray-600" />
                    {pendingTasksCount > 0 && (
                      <span className="absolute -top-2 -right-2.5 bg-rose-500 text-white text-xs font-normal rounded-full w-6 h-6 flex items-center justify-center">
                        {pendingTasksCount}
                      </span>
                    )}
                  </button>
                </div>)}
              {isDashboardRoute && (
                <div className="h-8 w-px bg-gray-300"></div>)}
              <TopRightPartnersDropdown partners={partners} />
            </div>
          } */}
        </div>
      </div>

      <div className="h-16"></div>
      <SideModal
        isOpen={isPendingTasksOpen}
        onClose={handlePendingTasksClose}
        level="high"
      >
        <PendingTasksModal
          onClose={handlePendingTasksClose}
          pendingTasks={pendingTasks}
        />
      </SideModal>
    </>
  );
};

const SearchContainer = tw.div`relative`;

export default TopNavbar;
